import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';
import DocumentLayout from '@/views/Pages/DocumentLayout.vue';
// GeneralViews
import NotFound from '@/views/GeneralViews/NotFoundPage.vue';

// Calendar
const Bulletin = () => import(/* webpackChunkName: "bulletin" */ '@/views/Bulletin/Bulletin.vue');
// Calendar
const Grievance = () => import(/* webpackChunkName: "grievance" */ '@/views/Grievances/Grievance.vue');
const GrievanceDetails = () => import(/* webpackChunkName: "grievance" */ '@/views/Grievances/GrievanceDetails.vue');
// Calendar
const Members = () => import(/* webpackChunkName: "members" */ '@/views/Members/Members.vue');
const UserPage = () => import(/* webpackChunkName: "members" */ '@/views/Members/UserPage.vue');
// Calendar
const Calendar = () => import(/* webpackChunkName: "extra" */ '@/views/Calendar/Calendar.vue');
// Charts
const Charts = () => import(/* webpackChunkName: "dashboard" */ '@/views/Charts.vue');

// Components pages
const Buttons = () => import(/* webpackChunkName: "components" */ '@/views/Components/Buttons.vue');
const Cards = () => import(/* webpackChunkName: "components" */ '@/views/Components/Cards.vue');
const GridSystem = () => import(/* webpackChunkName: "components" */ '@/views/Components/GridSystem.vue');
const Notifications = () => import(/* webpackChunkName: "components" */ '@/views/Components/Notifications.vue');
const Icons = () => import(/* webpackChunkName: "components" */ '@/views/Components/Icons.vue');
const Typography = () => import(/* webpackChunkName: "components" */ '@/views/Components/Typography.vue');

// Dashboard pages
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/Dashboard.vue');
const AlternativeDashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard/AlternativeDashboard.vue');
const Widgets = () => import(/* webpackChunkName: "dashboard" */ '@/views/Widgets.vue');

// Document Pages
const Letters = () => import(/* webpackChunkName: "documents" */ '@/views/Documents/Letters.vue')
const Circulars = () => import(/* webpackChunkName: "documents" */ '@/views/Documents/Circulars.vue')
const Directives = () => import(/* webpackChunkName: "documents" */ '@/views/Documents/Directives.vue')
const FlightSafety = () => import(/* webpackChunkName: "documents" */ '@/views/Documents/FlightSafety.vue')
const Miscellaneous = () => import(/* webpackChunkName: "documents" */ '@/views/Documents/Misc.vue')
const DocumentDetails = () => import(/* webpackChunkName: "documents" */ '@/views/Documents/DocumentDetails.vue')
// Schemes Pages
const TMU = () => import(/* webpackChunkName: "schemes" */ '@/views/Schemes/TMU.vue')
const SchemeList = () => import(/* webpackChunkName: "schemes" */ '@/views/Schemes/SchemeList.vue')
const MHWScheme = () => import(/* webpackChunkName: "mhw" */ '@/views/Schemes/AISuraksha.vue')
const SchemePage = () => import(/* webpackChunkName: "schemes" */ '@/views/Schemes/SchemePage.vue')
const PMU = () => import(/* webpackChunkName: "schemes" */ '@/views/Schemes/PMU.vue')
const Incident = () => import(/* webpackChunkName: "schemes" */ '@/views/Schemes/Incident.vue')
const Accident = () => import(/* webpackChunkName: "schemes" */ '@/views/Schemes/Accident.vue')
const Administrative = () => import(/* webpackChunkName: "schemes" */ '@/views/Schemes/Administrative.vue')
const Groupmedical = () => import(/* webpackChunkName: "schemes" */ '@/views/Schemes/Groupmedical.vue')
// Forms pages
const FormElements = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormElements.vue');
const FormComponents = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormComponents.vue');
const FormValidation = () => import(/* webpackChunkName: "forms" */ '@/views/Forms/FormValidation.vue');

// Maps pages
const GoogleMaps = () => import(/* webpackChunkName: "extra" */ '@/views/Maps/GoogleMaps.vue');
const VectorMaps = () => import(/* webpackChunkName: "extra" */ '@/views/Maps/VectorMaps.vue');

// Pages
const User = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/UserProfile.vue');
const Pricing = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Pricing.vue');
const TimeLine = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/TimeLinePage.vue');
const Login = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Login.vue');
const Home = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Home.vue');
const Register = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Register.vue');
const Lock = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/Lock.vue');
const ForgotPassword = () => import(/* webpackChunkName: "pages" */ '@/views/Pages/ForgotPassword.vue');

// TableList pages
const RegularTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/RegularTables.vue');
const SortableTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/SortableTables.vue');
const PaginatedTables = () => import(/* webpackChunkName: "tables" */ '@/views/Tables/PaginatedTables.vue');
let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  name: 'Components',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'cards',
      name: 'Cards',
      component: Cards
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }
  ]
};
let documentsMenu = {
  path: '/documents',
  component: DashboardLayout,
  redirect: '/documents/circulars',
  name: 'Documents',
  children: [


    // {
    //   path: '/directives/:id',
    //   name: 'Document Details',
    //   component: DocumentDetails
    // },
    // {
    //   path: '/flightsafety/:id',
    //   name: 'Document Details',
    //   component: DocumentDetails
    // },
    // {
    //   path: '/letters/:id',
    //   name: 'Document Details',
    //   component: DocumentDetails
    // },
    // {
    //   path: '/misc/:id',
    //   name: 'Document Details',
    //   component: DocumentDetails
    // },
    {
      path: 'circulars',
      name: 'Circulars',
      component: Circulars
    },
    {
      path: 'directives',
      name: 'Directives',
      component: Directives
    },
    {
      path: 'flightsafety',
      name: 'Flight Safety',
      component: FlightSafety
    },
    {
      path: 'letters',
      name: 'Letters',
      component: Letters
    },
    {
      path: 'misc',
      name: 'Miscellaneous',
      component: Miscellaneous
    },
    {
      path: ':type/:id',
      name: 'Document Details',
      component: DocumentDetails
    },
  ]
};
let schemesMenu = {
  path: '/schemes',
  component: DashboardLayout,
  redirect: '/schemes/list',
  name: 'Welfare Schemes',
  children: [
    {
      path: 'list',
      name: 'Scheme List',
      component: SchemeList
    },
    {
      path: 'mhw',
      name: 'Mutual Help Welfare',
      component: MHWScheme
    },
   
    {
      path: 'pmu',
      name: 'Permanently medically Unfit',
      component: PMU
    },
    {
      path: 'incident',
      name: 'Incident Grounding',
      component: Incident
    },
    {
      path: 'accident',
      name: 'Accident Grounding',
      component: Accident
    },
    {
      path: 'administrative',
      name: 'Administrative Grounding',
      component: Administrative
    },
    {
      path: 'groupmedical',
      name: 'Group Mediclaim Policy',
      component: Groupmedical
    },
    {
      path: ':id',
      name: 'Scheme Details',
      component: SchemePage
    },

  ]
};
let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/elements',
  name: 'Forms',
  children: [
    {
      path: 'elements',
      name: 'Form elements',
      component: FormElements
    },
    {
      path: 'components',
      name: 'Form components',
      component: FormComponents
    },
    {
      path: 'validation',
      name: 'Form validation',
      component: FormValidation
    }
  ]
};

let tablesMenu = {
  path: '/tables',
  component: DashboardLayout,
  redirect: '/table/regular',
  name: 'Tables menu',
  children: [
    {
      path: 'regular',
      name: 'Tables',
      component: RegularTables
    },
    {
      path: 'sortable',
      name: 'Sortable',
      component: SortableTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }
  ]
};

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  name: 'Maps',
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'vector',
      name: 'Vector Map',
      component: VectorMaps
    }
  ]
};

let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  name: 'Pages',
  redirect: '/pages/user',
  children: [
    {
      path: 'user',
      name: 'User Page',
      component: User
    },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ]
};

let authPages = {
  path: '/auth',
  component: AuthLayout,
  name: 'Authentication',
  redirect: '/auth/login',
  children: [
    {
      path: '/auth/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/auth/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/auth/register',
      name: 'Register',
      component: Register
    },
    // {
    //   path: '/auth/pricing',
    //   name: 'Pricing',
    //   component: Pricing
    // },
    {
      path: '/auth/lock',
      name: 'Lock',
      component: Lock
    },
    {
      path: '/auth/forgotpassword',
      name: 'Forgot Password',
      component: ForgotPassword
    },
    { path: '*', component: NotFound }
  ]
};

const routes = [
  {
    path: '/',
    redirect: '/auth/home',
    name: 'Home'
  },

  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  documentsMenu,
  schemesMenu,
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/dashboard',
    name: 'Dashboard ',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard
      },
      {
        path: 'alternative',
        name: 'Alternative',
        component: AlternativeDashboard,
        meta: {
          navbarType: 'light'
        }
      },
      {
        path: 'calendar',
        name: 'Calendar',
        component: Calendar
      },
      {
        path: 'charts',
        name: 'Charts',
        component: Charts
      },
      {
        path: 'bulletin',
        name: 'Bulletin',
        component: Bulletin
      },
      {
        path: 'grievances/:id',
        name: 'Grievance Details',
        component: GrievanceDetails
      },
      {
        path: 'grievances',
        name: 'Grievances',
        component: Grievance
      },
      {
        path: 'members/:id',
        name: 'Member Page',
        component: UserPage
      },
      {
        path: 'members',
        name: 'Members',
        component: Members
      },
      {
        path: 'widgets',
        name: 'Widgets',
        component: Widgets
      }
    ]
  },

  authPages,
];

export default routes;
